import { render } from "./Labropoulou.vue?vue&type=template&id=6679ebee"
import script from "./Labropoulou.vue?vue&type=script&lang=js"
export * from "./Labropoulou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__